import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { NEST_API_URL } from 'config/apiUrl'
import { camelizeKeys } from 'humps'
import { createNestToken, refreshRailsSession } from 'redux/slices/auth-slice'
import { store } from 'redux/store'
import { getDeviceFingerprint } from 'services/device-fingerprint'

class NestApiService {
  apiInstance: AxiosInstance

  constructor() {
    this.apiInstance = axios.create({
      baseURL: NEST_API_URL
    })

    this.apiInstance.interceptors.request.use((config) => {
      const token = store.getState().auth.nestToken

      return {
        ...config,
        headers: {
          Authorization: config.headers.Authorization || `Bearer ${token}`,
          'X-Device-Fingerprint': getDeviceFingerprint()
        }
      } as unknown as InternalAxiosRequestConfig
    })

    this.apiInstance.interceptors.response.use(
      (response) => ({ ...response, data: camelizeKeys(response.data) }),
      async ({ config, response }) => {
        // handle case where accessToken has been expired: refresh it!
        if (response && response.status === 401) {
          const { accessToken } = await store.dispatch(refreshRailsSession()).unwrap()
          const { token } = await store.dispatch(createNestToken({ accessToken })).unwrap()

          config.headers.Authorization = `Bearer ${token}`
          return axios.request(config)
        }

        return Promise.reject(response)
      }
    )
  }
}

const nestApiService = new NestApiService()

export default nestApiService
